<div class="loading_logo_claro">
    <div class="fill_1"></div>
    <div class="fill_2">
        <div></div>
    </div>
    <div class="fill_3"></div>
    <div class="fill_4"></div>
</div>